import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCross = props => (
  <SvgIcon {...props} viewBox="0 0 14 14">
    <path d="m14 1.4-1.4-1.4-5.6 5.6-5.6-5.6-1.4 1.4 5.6 5.6-5.6 5.6 1.4 1.4 5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6 5.6-5.6z" />
  </SvgIcon>
);

export default IconCross;



// WEBPACK FOOTER //
// ./src/components/icons/IconCross.js